import React, { useState, useEffect } from "react";
import ContentfulUtil from "../util/ContentfulUtil";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";
import BlogCard from "../components/blog/BlogCard";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const blogPosts = await ContentfulUtil.getBlogPosts();
        setPosts(blogPosts || []);
      } catch (err) {
        console.error("Failed to load blog posts:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <>
      <PageTitle>
        <div className="text-white h2 font-secondary mb-0">
          Spotlight News & Blog
        </div>
        <p className="text-lighten mb-0 mt-2" style={{ fontSize: "16px" }}>
          Stay up to date with Spotlight Players announcements, behind-the-scenes stories, and community news.
        </p>
      </PageTitle>

      <PageContent>
        {loading ? (
          <div className="row justify-content-center py-5">
            <div className="col-12 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading blog posts...</span>
              </div>
              <p className="mt-3 text-muted">Loading posts...</p>
            </div>
          </div>
        ) : posts.length === 0 ? (
          <div className="row justify-content-center py-5">
            <div className="col-md-8 text-center">
              <i className="ti-pencil-alt text-primary mb-3" style={{ fontSize: "48px", display: "inline-block" }} />
              <h3 className="text-secondary">No Blog Posts Yet</h3>
              <p className="text-muted mt-2">
                We are currently crafting exciting stories and announcements. Check back soon for the latest updates!
              </p>
              <a href="#/" className="btn btn-primary mt-3">
                Return to Home
              </a>
            </div>
          </div>
        ) : (
          <div className="row">
            {posts.map((post) => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        )}
      </PageContent>
    </>
  );
}
